import {Component, inject, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {
  faTriangleExclamation,
  faXmark,
  faChevronRight,
  faPlus,
  faMagnifyingGlass,
  faTrash,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import {Pagination} from "../../../../exam/feature/exam-submissions/exam-submissions.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {CourseService} from "../../../data-access/course.service";
import _ from "lodash";

@Component({
  selector: 'subsections-list',
  templateUrl: './subsections-list.component.html',
  standalone: false
})
export class SubsectionsListComponent implements OnInit {
  courseService = inject(CourseService);
  router = inject(Router);
  currentPagination: Pagination = {
    limit: 15,
    size: 0,
    page: 0,
    start: 0,
    totalcount: 0,
    maxpage: 0
  }
  my_subsections: any[] = []
  searchText = ''
  isLoading = false
  openFilters = false;
  courses: any[] = []
  filterStartDate: Date | undefined = undefined;
  filterEndDate: Date | undefined = undefined;
  _snackBar = inject(MatSnackBar)

  filters = {
    start_date: this.filterStartDate,
    end_date: this.filterEndDate,
    type: 'null',
    courses: 'null'
  }
  filter_type = 'null'
  course_name = 'null'
  subsection_types: any[] = []
  distinct_course_names: any[] = []
  my_courses: any[] = []
  show_delete_subsection_dialog = false
  delete_subsection_id = -1
  delete_subsection_name = ''
  edit_subsection_id = -1

  showCreateSubsection = false
  showEditSubsection = false

  create_subsection_info = {
    name: '',
    description: '',
    course_id: -1,
    type: 'null',
  }

  allSubsections = false

  ngOnInit() {
    this.handleServiceCall()

    this.courseService.getSubsectionTypes().subscribe((response) => {
      if(response.success) {
        this.subsection_types = response.result.types;
      }
    })

    this.courseService.getDistinctCourseNames().subscribe((response) => {
      if(response.success) {
        this.distinct_course_names = response.result.courses;
      }
    })

    this.courseService.getMyCourses().subscribe((response) => {
      // TODO need to complete this API
      if(response.success) {
        this.my_courses = response.result.items;
      }
    })
  }

  handleServiceCall() {
    this.isLoading = true;
    if(this.allSubsections) {
      this.courseService.getAllSubsections(this.searchText, this.currentPagination.page, this.currentPagination.limit, this.filters).subscribe((response) => {
        if(response.success) {
          this.my_subsections = response.result.items
          this.currentPagination.totalcount = response.result.count
          this.currentPagination.size = response.result.size
          this.currentPagination.page = response.result.page
          this.currentPagination.limit = response.result.limit
          this.currentPagination.maxpage = Math.floor(response.result.count / response.result.limit)  + 1
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
        }
        this.isLoading = false;

        console.log(this.currentPagination)
      })
    } else {
      this.courseService.getMySubsections(this.searchText, this.currentPagination.page, this.currentPagination.limit, this.filters).subscribe((response) => {
        if(response.success) {
          this.my_subsections = response.result.items
          this.currentPagination.totalcount = response.result.totalcount
          this.currentPagination.size = response.result.size
          this.currentPagination.page = response.result.page
          this.currentPagination.limit = response.result.limit
          this.currentPagination.maxpage = Math.floor(response.result.totalcount / response.result.limit)  + 1
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
        }
        this.isLoading = false;
      })
    }
  }

  debounceSearch = _.debounce(() => {
    this.handleServiceCall()
  }, 750)

  applyFilter() {
    this.filters.start_date = this.filterStartDate
    this.filters.end_date = this.filterEndDate
    this.filters.type = this.filter_type
    this.filters.courses = this.course_name
    this.handleServiceCall()
    this.openFilters = false;
  }

  resetFilters() {
    this.filterStartDate = undefined;
    this.filterEndDate = undefined;
    this.course_name = 'null';
    this.filter_type = 'null';
    this.filters = {
      start_date: this.filterStartDate,
      end_date: this.filterEndDate,
      type: 'null',
      courses: 'null'
    }
    this.handleServiceCall()
    this.openFilters = false;
  }

  confirmDeleteSubsection() {
    this.courseService.deleteSubsection(this.delete_subsection_id).subscribe((response) => {
      if(response.success) {
        this.show_delete_subsection_dialog = false
        this.delete_subsection_id = -1
        this.handleServiceCall()
        this._snackBar.open('Subsection successfully deleted', 'Dismiss', {duration: 3000})
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
    })
  }

  cancelSubsectionDialog() {
    this.create_subsection_info = {
      name: '',
      description: '',
      course_id: -1,
      type: 'null',
    }
    this.showCreateSubsection = false
    this.edit_subsection_id = -1
  }

  createSubsection() {
    this.courseService.createSubsection(this.create_subsection_info).subscribe((response) => {
      if(response.success) {
        this.cancelSubsectionDialog()
        this.handleServiceCall()
        this._snackBar.open('Subsection successfully created', 'Dismiss', {duration: 3000})
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
    })
  }

  // TODO implement API calls and add to the url query so we can go back to the correct tab
  allSubsectionsClick() {
    this.allSubsections = true
    this.handleServiceCall()
  }

  mySubsectionsClick() {
    this.allSubsections = false
    this.handleServiceCall()
  }

  openEditSubsectionDialog(subsection_id: number, subsection_name: string, course_id: number, description: string, type: string) {
    this.showCreateSubsection = true
    this.edit_subsection_id = subsection_id
    this.create_subsection_info = {
      name: subsection_name,
      course_id: course_id,
      description: description,
      type: type
    }
  }

  confirmEditSubsection() {
    this.courseService.editSubsection(this.edit_subsection_id, this.create_subsection_info).subscribe((response) => {
      if(response.success) {
        this.cancelSubsectionDialog()
        this.handleServiceCall()
        this._snackBar.open('Subsection successfully edited', 'Dismiss', {duration: 3000})
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
    })
  }

  navigateToSubsectionStudents(subsection_id: number, subsection_name: string) {
    this.router.navigate(['dashboard/subsections/students'], {queryParams: {subsection_id: subsection_id, subsection_name: subsection_name}})
  }

  protected readonly faMagnifyingGlass = faMagnifyingGlass;
  protected readonly faPlus = faPlus;
  protected readonly faXmark = faXmark;
  protected readonly faTrash = faTrash
  protected readonly faExclamationTriangle = faExclamationTriangle;
}
